import { Avatar } from "@mui/material";
import { getAvatarColor, getInitial } from "../tokens";

interface Props {
  email: string;
  size?: number;
}

/** Initial-only avatar with a colour derived from the editor's e-mail. */
const UserAvatar = ({ email, size = 18 }: Props) => (
  <Avatar
    sx={{
      width: size,
      height: size,
      fontSize: size * 0.48,
      fontWeight: 700,
      backgroundColor: getAvatarColor(email),
      color: "#FFFFFF",
    }}
  >
    {getInitial(email)}
  </Avatar>
);

export default UserAvatar;
